<template>
  <div class="testv__shownotes__wrapper">
    <SsButton2 type="text" class="testv__shownotes__btn__next"><IconNext/></SsButton2>
    <SsButton2 type="text" class="testv__shownotes__btn__prev"><IconPrev/></SsButton2>
    <swiper-container
      init="false"
      class="testv__shownotes__swiper__container">
      <swiper-slide
        class="testv__shownotes__item__wrapper"
        v-for="(item, index) in shownotes"
        :key="item.id">
        <div class="testv__shownotes__item">
          <div class="testv__shownotes__item__head">
            <span>SHOWNOTES.{{ index + 1 }}/{{ length }}</span>
            <span>{{ item.time_slot | formatTime }}</span>
          </div>
          <div class="testv__shownotes__item__body">
            <div class="testv__shownotes__item__img__wrapper">
              <img :src="$imageUrl(item.banner)" alt="" />
            </div>
            <div class="testv__shownotes__item__intro">{{ item.intro }}</div>
          </div>
        </div>
      </swiper-slide>
    </swiper-container>
  </div>
</template>

<script>
import { register } from 'swiper/swiper-element-bundle'
register()

export default {
  name: 'TestvShownotes',

  components: {
  },

  props: {
    shownotes: Array
  },

  computed: {
    length () {
      return (this.shownotes && this.shownotes.length) || 0
    }
  },

  filters: {
    formatTime (time) {
      if (!time) return '00 : 00'
      const m = parseInt(time / 60)
      const s = time % 60
      return `${m > 9 ? m : `0${m}`} : ${s > 9 ? s : `0${s}`}`
    }
  },

  methods: {
  },

  mounted () {
    const swiperEl = document.querySelector('swiper-container')
    const params = {
      navigation: {
        nextEl: '.testv__shownotes__btn__next',
        prevEl: '.testv__shownotes__btn__prev'
      }
    }
    Object.assign(swiperEl, params)
    swiperEl.initialize()
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/assets/styles/variable.styl'
.testv__shownotes__wrapper {
  position: relative;
  .testv__shownotes__btn__next,
  .testv__shownotes__btn__prev {
    visibility: hidden;
    position: absolute;
    width: 48px;
    height: 48px;
    border: 1px solid var(--dark-bwb-3)!important;
    border-radius: 50%;
    color: var(--dark-bwb-8);
    top: calc(50% - 16px);
    svg {
      width: 32px;
      height: 32px;
      vertical-align: middle;
    }
    @media (min-width: $screen-md) {
      visibility: visible;
    }
  }
  .testv__shownotes__btn__next {
    right: 0;
  }
  .testv__shownotes__btn__prev {
    left: 0;
  }
}
.testv__shownotes__swiper__container {
  max-width: 560px;
  display: flex;
  align-items: stretch;
}
.testv__shownotes__item__wrapper {
  height: auto;
}
.testv__shownotes__item {
  height: 100%;
  box-sizing: border-box;
  border: 1px solid var(--dark-bwb-2);
  border-radius: 8px;
  .testv__shownotes__item__head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px;
    font-family: "DottedSongtiSquare";
    font-size: 13px;
    line-height: 1;
    color: var(--dark-bwb-5);
    border-bottom: 1px solid var(--dark-bwb-2);
    @media (min-width: $screen-md) {
      padding: 8px 16px;
    }
  }
  .testv__shownotes__item__body {
    padding: 16px;
    text-align: center;
    img {
      border-radius: 8px;
      max-height: 170px;
    }
    .testv__shownotes__item__intro {
      margin-top: 16px;
      font-size: 13px;
      color: var(--dark-bwb-8);
    }
    @media (min-width: $screen-md) {
      display: flex;
      column-gap: 16px;
      .testv__shownotes__item__img__wrapper {
        flex-shrink: 0;
      }
      img {
        width: 240px;
        min-height: auto;
      }
      .testv__shownotes__item__intro {
        font-size: 15px;
        margin-top: 0px;
        text-align: left;
      }
    }
  }
}
</style>
